import {
  GET_VOCABULARY,
  GET_VOCABULARY_SUCCESS,
  GET_VOCABULARY_ERROR,
} from "../actions";

const INIT_STATE = {
  vocabularyId: null,
  vocabulary: null,
  vocabularyDetailsError: "",
  recordList : null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_VOCABULARY:
      return {
        ...state,
        loading: true,
        vocabularyId: action.payload.vocabularyId,
        vocabularyDetailsError: "",
      };
    case GET_VOCABULARY_SUCCESS:
      return {
        ...state,
        loading: false,
        vocabularyDetailsError: "",
        vocabulary: action.payload.vocabulary
      };
    case GET_VOCABULARY_ERROR:
      return { ...state, loading: false, vocabularyDetailsError: action.payload ? action.payload.message : "" };
    default:
      return { ...state };
  }
};
